import { Button, IconButton } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { useLocation, useNavigate} from 'react-router-dom'
import { useAppDispatch } from '../../../State/Store';
import { paymentSuccessHandler } from '../../../State/customer/OrderSlice';
import { Celebration } from '@mui/icons-material';
import { red } from '@mui/material/colors';
import { resetCart } from '../../../State/customer/CartSlice';
export const PaymentSuccess = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const location = useLocation();


    // Persistent State Across Renders:

// The value of useRef persists across renders, which means even if the component re-renders, the value remains unchanged unless explicitly modified.
// In this case, calledOnce is a ref initialized to false. It will remain false until it’s explicitly set to true.
// No Re-render Trigger:

// Unlike useState, updating a useRef value does not cause a re-render. When calledOnce.current is set to true, it prevents subsequent calls to handleDispatchPaymentHandler without affecting the component’s render cycle.
// Safe Execution Guard:

// The check if (!calledOnce.current) ensures that the handler is called only on the first execution of useEffect. Subsequent renders will skip this block as calledOnce.current will already be true.

    const calledOnce = useRef(false); // Ref to ensure single execution

    const getQueryParam = (key:string) => { 
        const query = new URLSearchParams(location.search)
        return query.get(key);
     }
     const paymentId = getQueryParam("paymentId");
     const handleDispatchPaymentHandler = async (paymentId: string | null) => {
        try {
          if (paymentId != null) {
            await dispatch(paymentSuccessHandler(paymentId)).unwrap();
            await  dispatch(resetCart()).unwrap();
          }
        } catch (error) {
          console.error("Error during payment handling:", error);
        }
      };
     
      useEffect(() => {
        if (!calledOnce.current) {
          // Ensure this block runs only once
          calledOnce.current = true;
          handleDispatchPaymentHandler(paymentId);
        }
      }, []); // Dependency on `paymentId`
     
  return (
    <div className='min-h-[90vh] flex justify-center items-center'>
        <div className="bg-primary text-white p-8 w-[90%] lg:w-[30%] border-rounded-md h-[40vh] flex flex-col gap-7 items-center justify-center">
            
            <h1 className='text-3xl font-semibold'>
            <span>
                    <IconButton sx={{color:red[400]}} >
                        <Celebration sx={{fontSize:"3rem"}}/>
                    </IconButton>
                </span>
                Congratulations!
                <span>
                    <IconButton sx={{color:red[400]}} >
                        <Celebration sx={{fontSize:"3rem"}}/>
                    </IconButton>
                    
                </span>
            </h1>
            <h1 className='text-2xl font-semibold'>Your Order Has Been Paid Successfully </h1>
            <div className="">
                <Button color='secondary' variant='contained' onClick={() => { navigate("/") }}>
                    Shop More
                </Button>
            </div>
        </div>
    </div>
  )
}
